export const shuffle = (input: string[]) => {
  const leftsize = Math.ceil(input.length / 2);
  const output = [];
  for (let i = 0; i < leftsize; i++) {
    output.push(input[i]);
    if (input[leftsize + i]) output.push(input[leftsize + i]);
  }
  return output;
};

export const orderItems = (
  keys: string[],
  sortedArray: string[],
  shouldShuffle = true
) => {
  const sortedItems = sortedArray.filter(item =>
    keys.includes(item) ? item : false
  );
  return shouldShuffle ? shuffle(sortedItems) : sortedItems;
};

export const humanizeList = (
  list: React.ReactNode[],
  options = {
    conjunction: 'and',
    skipConjunction: false,
    oxfordComma: true
  }
): React.ReactNode[] => {
  if (!list || !list.length) {
    return [];
  }

  options = options || {};
  const { conjunction, skipConjunction, oxfordComma } = options;

  const listLength = list.length;

  if (listLength === 1) {
    return list;
  }

  if (skipConjunction) {
    // Return the list with commas between items
    return list.reduce((acc: React.ReactNode[], item, index) => {
      if (index > 0) {
        acc.push(', ');
      }
      acc.push(item);
      return acc;
    }, []);
  }

  const humanizedList: React.ReactNode[] = [];

  for (let i = 0; i < listLength; i++) {
    humanizedList.push(list[i]);

    if (i === listLength - 2) {
      if (oxfordComma && listLength > 2) {
        humanizedList.push(',');
      }
      humanizedList.push(` ${conjunction} `);
    } else if (i < listLength - 2) {
      humanizedList.push(', ');
    }
  }

  return humanizedList;
};
